type AnyObject = { [key: string]: any };

export function replaceCurrencyDeep<T>(input: T, newCurrency: string): T {
  if (Array.isArray(input)) {
    return input.map((item) => replaceCurrencyDeep(item, newCurrency)) as T;
  }

  if (input !== null && typeof input === "object") {
    const result: AnyObject = {};
    for (const [key, value] of Object.entries(input)) {
      if (key === "currency" || key === "currencyCode") {
        result[key] = newCurrency;
      } else {
        result[key] = replaceCurrencyDeep(value, newCurrency);
      }
    }
    return result as T;
  }

  return input;
}
